const pushSectionView = ({ section, subsection1, subsection2 }) => {
  const fullHierarchy = `${section}:${subsection1}:${subsection2}`;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'section_view',
    section,
    subsection_1: subsection1,
    subsection_2: subsection2,
    full_hierarchy: fullHierarchy
  });
};

export const trackVisibleSections = ({
  rootSelector,
  section = 'landing',
  subsection1,
  threshold = 0.5
}) => {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return () => {};
  }

  const root = rootSelector ? document.querySelector(rootSelector) : document;
  if (!root) {
    return () => {};
  }

  const sections = root.querySelectorAll('[data-section]');
  if (!sections.length) {
    return () => {};
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (window.isProgrammaticScroll) {
          return;
        }

        if (!entry.isIntersecting || entry.intersectionRatio < threshold) {
          return;
        }

        const subsection2 = entry.target.dataset.section;

        if (!subsection2) {
          return;
        }

        pushSectionView({ section, subsection1, subsection2 });
      });
    },
    { threshold }
  );

  sections.forEach((item) => observer.observe(item));

  return () => observer.disconnect();
};
